(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /* NOTE: Liquid is NOT rendered inside this tag. Anything Liquid-ish
     left in here is a syntax error and takes the whole theme scripts
     bundle down with it. Read the values from the markup (data
     attributes) instead. */

  (() => {
    const FALLBACK_URL = '/';
    const FALLBACK_LABEL = 'Continue shopping';

    function readConfig() {
      const el = document.querySelector('.rulo-cart-data');

      return {
        url: (el && el.dataset.continueUrl) || FALLBACK_URL,
        label: (el && el.dataset.continueLabel) || FALLBACK_LABEL,
      };
    }

    function buildContinueButton(config) {
      const link = document.createElement('a');

      link.className = 'button rulo-continue-shopping';
      link.href = config.url;

      const text = document.createElement('span');

      text.className = 'button-text';
      text.textContent = config.label;

      link.appendChild(text);

      return link;
    }

    /* Cart page only - never the header cart drawer. */

    function injectContinueButton() {
      const groups = document.querySelectorAll('.cart-page__summary .cart__ctas');

      if (!groups.length) return;

      const config = readConfig();

      for (const group of groups) {
        const checkout = group.querySelector('#checkout, .cart__checkout-button');

        if (!checkout) continue;

        const existing = group.querySelector('.rulo-continue-shopping');

        if (existing) {
          if (existing.previousElementSibling !== checkout) checkout.after(existing);
          continue;
        }

        checkout.after(buildContinueButton(config));
      }
    }

    let pending = false;

    function scheduleInject() {
      if (pending) return;

      pending = true;

      setTimeout(() => {
        pending = false;

        injectContinueButton();
      }, 0);
    }

    function start() {
      injectContinueButton();

      /* The cart section is re-rendered (morphed) whenever the cart
         changes, which wipes out any injected markup. Re-add it. */

      new MutationObserver(scheduleInject).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
